import { screenXsMax } from '@spotify-internal/encore-foundation';
import { cssColorValue, cssSpacing, semanticColors } from "../../styles/index.js";
import styled from "../../styled-components.js";
export var IndicatorText = styled.span.withConfig({
  displayName: "IndicatorText",
  componentId: "sc-7u3ecx-0"
})(["color:", ";padding-inline-start:", ";@media (max-width:", "){flex:1;}"], cssColorValue(semanticColors.textSubdued), cssSpacing('tighter-4', '4px'), screenXsMax);